import { MicIcon, SpeakerIcon, VideoIcon } from "lucide-react";
import DeviceSelectorButton from "@component/device-selector-buttons";


export function MicrophoneSelector({
    label = "MacBook Pro Microphone",
    onClick,
    className,
}: {
    label?: string;
    onClick?: () => void;
    className?: string;
}) {
    return (
        <DeviceSelectorButton
            icon={<MicIcon className="h-8 w-8" />}
            label={label}
            onClick={onClick}
            className={className}
        />
    );
}

export function SpeakerSelector({
    label = "MacBook Pro Speakers",
    onClick,
    className,
}: {
    label?: string;
    onClick?: () => void;
    className?: string;
}) {
    return (
        <DeviceSelectorButton
            icon={<SpeakerIcon className="h-8 w-8" />}
            label={label}
            onClick={onClick}
            className={className}
        />
    );
}

export function CameraSelector({
    label = "MacBook Pro Camera (HD)",
    onClick,
    className,
}: {
    label?: string;
    onClick?: () => void;
    className?: string;
}) {
    return (
        <DeviceSelectorButton
            icon={<VideoIcon className="h-8 w-8" />}
            label={label}
            onClick={onClick}
            className={className}
        />
    );
}

export function DeviceSelector({
    icon,
    label,
    onClick,
    className,
}: {
    icon: React.ReactNode;
    label: string;
    onClick?: () => void;
    className?: string;
}) {
    return (
        <DeviceSelectorButton
            icon={icon}
            label={label}
            onClick={onClick}
            className={className}
        />
    );
}
